<div class="container marginMobile">
  <div class="col-sm-12 breadcrumb py-3 m-0">
    <a [routerLink]="['/series']">Séries</a>&nbsp;>&nbsp;<a href="#">{{brand}}</a>
  </div>
</div>
<div class="container">
   <div class="row">
     <div class="col-12 filterBtn  text-center">
           <button type="button" class="filterMobile closeFilter" name="button" onclick="showFiltre()">Fermer le filtre <i class="fa fa-times" aria-hidden="true"></i>
         </button>
           <button type="button" class="filterMobile openFilter" name="button" onclick="showFiltre()">Filtrer <i class="fa fa-filter" aria-hidden="true"></i>
         </button>
     </div>
     <div class="col-12 col-md-4 col-xl-3 sideFiltre" id="sideFiltre">
       <button class="btn btn-primary titreSideBar brandcollapse" type="button" data-bs-toggle="collapse" data-bs-target="#fournisseur" aria-expanded="false" aria-controls="collapseExample">
           Séries <i class="fa fa-chevron-right fa-rotate-90 categoryIcon" aria-hidden="true"></i>
       </button>
       <div class="collapse show" id="fournisseur">
         <div class="f3">
           <div class="list-group">
             <div class="custom-control custom-checkbox p-2 ">
                 <input type="radio" class="custom-control-input" name="serie" checked (change)="getAllProducts(idFournisseur)">
                 <label class="custom-control-label ml-2 c2"  for="defaultUnchecked">Tous les produits</label>
             </div>
             <div *ngFor="let categorie of allCategories" >
               <div class="custom-control custom-checkbox p-2 c1" *ngIf="allCode33.includes(categorie.id)">
                    <input  type="radio" class="custom-control-input" name="serie" (change)="filtreBySerie(categorie.id)">
                   <!--<label  class="custom-control-label ml-2 c2" for="defaultUnchecked">{{categorie.ITMDES1}}</label> -->
                   <label  class="custom-control-label ml-2 c2" for="defaultUnchecked" >{{categorie.name}}</label>
               </div>
             </div>

           </div>
         </div>
       </div>
      </div>
      <div class="col-12 col-md-8 col-xl-9">
        <div class="container">
          <div class="row">
            <div class="col-sm-12 triProducts mb-4 text-end">
              <div class="triAffichage">
                Affichage :
                <select class="form-select selectAffichage" (change)="changeMax($event.target.value)" aria-label="Default select example">
                  <option value="12">x 12 Produits</option>
                  <option value="22">x 22 Produits</option>
                  <option value="44">x 44 Produits</option>
                  <option value="88">x 88 Produits</option>
                </select>
              </div>
            </div>
            <div class="flash text-center" *ngIf="!products">
              <img src="assets/front/images/logo.png"/>
            </div>
            <div class="col-6 col-md-6 col-lg-4" *ngFor="let product of products | paginate: {itemsPerPage: pageSize,currentPage: page,totalItems: total }">
              <app-card-product [product]="product" ></app-card-product>
            </div>
            
            <nav aria-label="Page navigation example">
              <ul class="pagination justify-content-center">
                <li class="page-item"><a class="page-link" (click)="previousPage()">Previous</a></li>
                <li class="page-item" *ngFor="let pageNumber of pageNumbers" [class.active]="pageNumber == startIndex" (click)="goToPage(pageNumber)">
                  <a class="page-link">{{ pageNumber }}</a>
                </li>
                <li class="page-item"><a class="page-link" (click)="nextPage()">Next</a></li>
              </ul>
            </nav>

          </div>
        </div>
      </div>
   </div>
</div>
